import { TFunction } from "i18next";

/**
 * Which Workflows builder option list a key belongs to. One prefix per API enum, so the
 * measurement and survey-score comparator lists share their `comparator` keys.
 */
export type WorkflowOptionList =
  | "ruleType"
  | "comparator"
  | "trigger"
  | "dateEvent"
  | "fibricheckStatus"
  | "aliveCorEcgStatus"
  | "spirometryStatus"
  | "occurrencePeriod"
  | "sleepStage"
  | "activityMetric"
  | "responseType"
  | "responseTime"
  | "actionType";

/**
 * The label for a Workflows builder dropdown option, in the user's language.
 *
 * EN-5282: the API sends these lists as `{ type, name }` with an English `name`, and the
 * builder showed `name` as-is, so the options stayed English in every language. The key is
 * built from `type` (the enum the option saves), never from `name`, so translating a label
 * cannot change what is stored.
 *
 * The API's `name` remains the fallback: a type added to the API before the portal carries a
 * key for it still reads as English rather than as a raw key.
 */
export function getWorkflowOptionLabel(
  list: WorkflowOptionList,
  option: { type: string; name: string },
  t: TFunction
): string {
  const type = option.type.charAt(0).toLowerCase() + option.type.slice(1);

  return t(`workflows_options_${list}_${type}`, { defaultValue: option.name });
}
